import axios from 'axios';

//const SERVER_URL = "https://smartlight.bhtelecom.ba:3102/api/auth/";

const SERVER_URL = "https://smartlight-backend-authentication-smartlight.apps.okd-prod.smart-iot.bhtelecom.ba";
//const SERVER_URL = process.env.REACT_APP_AUTHENTICATION_BACKEND_SERVER_URL;

/*
const httpsAgent = new https.Agent({
  rejectUnauthorized: false, // (NOTE: this will disable client verification)
  key: fs.readFileSync('/etc/letsencrypt/live/maticnaknjiga.com/privkey.pem'), // Replace with the path to your key
  cert: fs.readFileSync('/etc/letsencrypt/live/maticnaknjiga.com/fullchain.pem'), // Replace with the path to your certificate
  passphrase: "goldman"
})
*/

const register = (username, email, password) => {
  return axios.post(SERVER_URL + "/api/auth/signup", {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  return axios
    .post(SERVER_URL + "/api/auth/signin", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

export default {
  register,
  login,
  logout,
};
